const OrissaData =[
    {
        
        City: "",
        nameOfResource: "Ambulance",
        Address: "",
        Contact: "",
        Price: " ",
        Comments: "",
        verficationDataTime: "",
        vendorName: "",
    },
    {
    
        City: "",
        nameOfResource: "Beds",
        Address: "",
        Contact: "",
        Price: " ",
        Comments: "",
        verficationDataTime: "",
        vendorName: "",
    },
    {
    
        City: "",
        nameOfResource: "bloodBanks",
        Address: "",
        Contact: "",
        Price: " ",
        Comments: "",
        verficationDataTime: "",
        vendorName: "",
    },
    {
    
        City: "",
        nameOfResource: "foodDistribution",
        Address: "",
        Contact: "",
        Price: " ",
        Comments: "",
        verficationDataTime: "",
        vendorName: "",
    },
    {
    
        City: "",
        nameOfResource: "homeCare",
        Address: "",
        Contact: "",
        Price: " ",
        Comments: "",
        verficationDataTime: "",
        vendorName: "",
    },
    {
    
        City: "",
        nameOfResource: "Medicines",
        Address: "",
        Contact: "",
        Price: " ",
        Comments: "",
        verficationDataTime: "",
        vendorName: "",
    },
    {
    
        City: "",
        nameOfResource: "resourceAgencies",
        Address: "",
        Contact: "",
        Price: " ",
        Comments: "",
        verficationDataTime: "",
        vendorName: "",
    },
    {
    
        City: "",
        nameOfResource: "womenInCardiology",
        Address: "",
        Contact: "",
        Price: " ",
        Comments: "",
        verficationDataTime: "",
        vendorName: "",
    },
    {
    
        City: "",
        nameOfResource: "humanSupporters",
        Address: "",
        Contact: "",
        Price: " ",
        Comments: "",
        verficationDataTime: "",
        vendorName: "",
    },
    {
    
        City: "",
        nameOfResource: "Oxygen",
        Address: "",
        Contact: "",
        Price: " ",
        Comments: "",
        verficationDataTime: "",
        vendorName: "",
    },
    {
    
        City: "",
        nameOfResource: "oxygenCylinder",
        Address: "",
        Contact: "",
        Price: " ",
        Comments: "",
        verficationDataTime: "",
        vendorName: "",
    },
    {
    
        City: "",
        nameOfResource: "oxygenRefill",
        Address: "",
        Contact: "",
        Price: " ",
        Comments: "",
        verficationDataTime: "",
        vendorName: "",
    },
    {
    
        City: "",
        nameOfResource: "plasmaDonors",
        Address: "",
        Contact: "",
        Price: " ",
        Comments: "",
        verficationDataTime: "",
        vendorName: "",
    },
    {
    
        City: "",
        nameOfResource: "testingCenters",
        Address: "",
        Contact: "",
        Price: " ",
        Comments: "",
        verficationDataTime: "",
        vendorName: "",
    },

];


export default OrissaData